export default {
  init() {
    // JavaScript to be fired on the home page
    var button = document.querySelector('.nav__button');
    var nav = document.querySelector('.nav');
    button.addEventListener('click', function(){
      nav.classList.toggle('nav--open');
    });

    // JavaScript to be fired on all pages
    // Slider for Testimonies
    var btn = document.querySelectorAll('.btn__testimonies');
    var element = document.querySelectorAll('.liste--testimonies__el');
    var temp = 0;

    // Cacher les autres avis et laisser le premier affiché
    for(let i = 0; i < element.length; i++){
      if (i != 0) {
        element[i].classList.add('d-none');
      }  
    }

    for(let i = 0; i < btn.length; i++){
      btn[i].addEventListener('click', function(){
        // console.log('click');
        if (i == 0) {
          if (temp == element.length - 1) {
            temp = 0;
          } else {
            temp++;
          }
        } else {
          if (temp == 0) {
            temp = element.length - 1;
          } else {
            temp--;
          }
        }
        // console.log('Le i : ' + temp);
        for(let i = 0; i < element.length; i++){
          element[i].classList.add('d-none');
        }
        element[temp].classList.remove('d-none');
      });
    }

    
    setTimeout(function() {
      // AGRANDISSEMENT
      const oeuvre = document.querySelector('.container--video');
      if (oeuvre != null) {

      const test = $('.container--video');
      const titleWidth = document.querySelector('.header__text').offsetWidth;

      var hauteurScrollDiv = getOffset(oeuvre).top;
      var hauteurSectionThree = getOffset(document.querySelector('.section--three')).top;

      var lastScrollTop = 0;
      var temp = 0;

      $(window).scroll(function(){
        const scrollTop = window.pageYOffset - oeuvre.offsetTop;
        // console.log('Scroll : ' + scrollTop);
        var st = $(this).scrollTop();
        if (st < hauteurSectionThree) {
          var widthWindow = window.innerWidth;
          let taille = titleWidth;
          var tempon = document.querySelector('.container--video').offsetWidth;
          let width = (st * 1.5) + (taille - 30);

          if (scrollTop <= 0) {
            if(widthWindow < 760) {
              test.css({
                'max-width': width,
                'transform': 'translateY('+(st) + 'px))',
              }, 1000, 'easeInOutSine');
            } else {
              test.css({
                'max-width': width,
                'transform': 'translateY(-'+(st / 10) + 'px)',
              }, 1000, 'easeInOutSine');
            }
          } else {
            if(st > (hauteurScrollDiv / 2) && width < titleWidth) {
              width = titleWidth;
              test.css({
                'max-width': width,
              }, 500, 'easeInOutSine');
            }
            if (st > (hauteurScrollDiv / 5)) {
              temp++;
              if (st > lastScrollTop){
                // console.log('Scroll down');
                width = tempon - (temp / 70);
              } else {
                // console.log('Scroll up');
                width = tempon + (temp / 70);
              // upscroll code
              }
              if (width < titleWidth) {
                width = titleWidth;
                tempon = 0;
              }
              // console.log(width);
              lastScrollTop = st;
              test.css({
                'max-width': width,
                // 'transform': 'rotate('+ st +'deg)',
              }, 500, 'easeInOutSine');
            }
          }
        }
      });
    }
    }, 1000);      

    // JS POUR LA PARTIE MAGASIN SUR LA PAGE CONTACT
    var elSelect = document.querySelector('.find__liste__el--select');
    var listeSelect = document.querySelector('.find__liste');
    var listeSelectElement = document.querySelectorAll('.find__liste__el--menu');
    var listeResult = document.querySelectorAll('.find_result__el');
    console.log(listeResult);
    var textButton = document.querySelector('.find__text');
    if (elSelect) {
      elSelect.addEventListener('click', function () {
        listeSelect.classList.toggle('find__liste--open');
      });
  
      for (var i = 0; i < listeSelectElement.length; i++) {
        listeSelectElement[i].addEventListener('click', function (e) {
            var ville = e.target.innerText;
            let villeRemplace = ville.replace(/ /g,'_');
            textButton.innerHTML = ville;
            listeSelect.classList.remove('find__liste--open');
            for (var i = 0; i < listeResult.length; i++) {
              console.log('Dans la boucle');
              if(listeResult[i].classList.contains(villeRemplace)) {
                listeResult[i].classList.add('show');
                console.log('Il y a le : ' + i);
              } else {
                listeResult[i].classList.remove('show');
              }
            }
            var test = document.querySelectorAll('.show');
            for (var u = 0; u < test.length; u++) {
              
              if((u - 1) % 3 == 0) {
                test[u].classList.add('entre-deux');
              } else {
                test[u].classList.remove('entre-deux');
              }
            }
        });  
      }
    }

    

    // var gfield = document.querySelectorAll('.gfield');
    // var listeForm = document.querySelectorAll('.gfield .gfield_label');
    
    // if(gfield) {
    //   for (let temp = 0; temp < gfield.length; temp++) {
    //     gfield[temp].addEventListener('click', function () {
    //       listeForm[temp].classList.add('label--actif');
    //     });
    //     gfield[temp].addEventListener('keydown', function () {
    //       listeForm[temp].classList.add('label--actif');
    //     });
    //   }
    //   var sterox = document.querySelectorAll('.sterox__schema__el');
    //   if(sterox.length > 0) {
    //     for (let e = 0; e < gfield.length; e++) {
    //       sterox[e].addEventListener('click', function () {
    //         sterox[e].classList.toggle('sterox__schema__el--actif');
    //       });
    //     }
    //   }
    // }  
    
    // SECTION FAQ
    var faq = document.querySelectorAll('.section--faq .card--modeof');

    if(faq) { 
      for (let e = 0; e < faq.length; e++) {
        faq[e].addEventListener('click', function () {
          faq[e].classList.toggle('show');
        });
      }
    }
    
    if($('.header__wisiwig')) {
      setTimeout(function() {
        $('.header__wisiwig a').click(function(){
          // console.log('oui');
          var lienHref=$(this).attr('href');
          // console.log(lienHref);
          var positionHrefTop=$(lienHref).offset().top;
          // console.log(positionHrefTop);
          $('html,body').animate({scrollTop:positionHrefTop-100},1000);
          return false;
        });
      }, 1500);       
    }


    // var cardNews = document.querySelectorAll('.card--news__el');
    // console.log(cardNews);

    // if(cardNews) {
    //   var btnMore = document.querySelector('.news__event .btn');
    //   var ilAClique = false;
    //   console.log(btnMore);
    //   for(let boucle = 4; boucle < cardNews.length; boucle++) {
    //     cardNews[boucle].classList.add('card--news__el--hidden');
    //   }

    //   btnMore.addEventListener('click', function (e) {
    //     e.preventDefault();
    //     console.log('click');
    //     if(ilAClique != true) {
    //       ilAClique = true;
    //       console.log('true');
    //       for(let boucle = 4; boucle < cardNews.length; boucle++) {
    //         cardNews[boucle].classList.remove('card--news__el--hidden');
    //       }
    //     }
    //     else {
    //       ilAClique = false;
    //       console.log('false');
    //       for(let boucle = 4; boucle < cardNews.length; boucle++) {
    //         cardNews[boucle].classList.add('card--news__el--hidden');
    //       }
    //     }
    //   });
        

    // }
    

    // // The lines below are executed on page load
    // test.each(function() {
      
    // });
    
    // // The lines below (inside) are executed on change & keyup
    // test.on('change keyup', function() {
    //   checkForInput(this);  
    // });
   

    // // var container = document.querySelector('.container');
    // var fenetre = $( window ).width();
    // var header = document.querySelector('.header__video');
    // var section = document.querySelector('.section--three ');
    // console.log(fenetre - 1140);
    // header.style.left = (((fenetre - 1140) / 2) + 15) + 'px';

    

    // // console.log);

    // var hauteursection = section.offsetHeight / 2;

    // window.onscroll = function() {addClass()};

    // function addClass() {
    //     if (window.pageYOffset > hauteurHeader){
    //         header.classList.add('sticky');
    //     }
    //     if (window.pageYOffset < hauteursection){
    //       header.classList.remove('sticky');
    //   }
    //     else {
    //         header.classList.remove('sticky');
    //     }
    // }

    $('#prev-posts-link').on('click', 'a', function(e) {
      e.preventDefault();
   
      let $this = $(this);
      let href = $this.attr('href');
   
      $.ajax(href)
          .done(function(data) {
   
              //get next article and push at the end
              let targetArticle = $(data).find('#card-container').html();
              $('#card-container').append( targetArticle );
   
              //update button
              let targetBtn = $(data).find('#prev-posts-link').html();
              if(targetBtn == null) {
                  $('#prev-posts-link').remove();
              } else {
                  $('#prev-posts-link').html(targetBtn);
              }
   
          })
          .fail(function(jqxhr) {
              alert(jqxhr.responseText);
          });
   
    });

    $('#past-events').on('click', function(e) {
      e.preventDefault();

      let $this = $(this);
      let currentPage = parseInt(this.search.split('=')[1]);
      console.log(currentPage);
      let href = $this.attr('href');

      let maxPage = $('#past-events').attr( 'data-maxpage' );
      console.log('Max de pages : ' + maxPage);

      $('a').prop('href', '?calendar_new='+(currentPage + 1)+'&more=true');
      $.ajax(href)
          .done(function(data) {
              //get next article and push at the end
              $('.calendar').empty();
              let targetArticle = $(data).find('#calendar-container').html();
              $('#calendar-container').append( targetArticle );
              $('#past-events').remove();
              // update button
              // let targetBtn = $(data).find('#past-events').html();
              // if(currentPage >= maxPage) {
              //     $('#past-events').remove();
              // } else {
              //     $('#past-events').html(targetBtn);
              // }
   
          })
          .fail(function(jqxhr) {
              alert(jqxhr.responseText);
          });
   
    });

    setTimeout(function() {
      var sectionStory = document.querySelector('.section--story');
      var circleDate = $('.date__circle');
      if (sectionStory) {
        $(window).scroll(function(){
          var widthWindow = window.innerWidth;
          let scroollTop = window.scrollY - (sectionStory.offsetTop - 250);
          if (widthWindow) {
            if (widthWindow < 400) {
              console.log('Petit de 400');
              scroollTop = window.scrollY - (sectionStory.offsetTop - 250);
              if(scroollTop >= 1264) {
                scroollTop = 1264;
              }
            }
            if (widthWindow >= 900) {
              scroollTop = window.scrollY - (sectionStory.offsetTop - 300);
              if (scroollTop > 754) {
                scroollTop = 754;
              }
            }
          }
          if (scroollTop >= 0) {
            circleDate.css({
              'transform': 'translateY('+ scroollTop+'px)',
            }, 1000, 'easeInOutSine');
          }
        });
      }

      // TECHNOLOGY TIMED ANIMATION RUNNING
      const oeuvre = document.querySelector('.modeof__content');
      if(oeuvre) {
        $(window).scroll(function(){
          const scrollTop = window.pageYOffset - (oeuvre.offsetTop + 100);
          if (scrollTop >= 0) {
            $('.show').addClass('animation-running');
          }
        });
      }
    }, 1000, 'easeInOutSine');
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  console.log(rect);
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  };
}

$('#monBtn').on('click', function() {
  // je récupère mon url
  // je check si ma page active < que maxNumPage
  // je fais ma requete ajax
});


// WEBPACK FOOTER //
// ./scripts/routes/common.js